sessionStorage.setItem('API_BASE','https://pvista.proevento.com.br/_soap/flash/');
export const API_BASE = 'https://pvista.proevento.com.br/_soap/flash/';